module.exports = __webpack_public_path__ + "img/ach_yes.e50e0c25.png";